import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

// One cell of the dashboard's stat strip. Cells sit side by side inside a
// single bordered container, so each one stays compact: a small icon + label
// row, the value, and an optional one-line hint.
const CellContent = ({ icon: Icon, label, value, secondary, linked }) => (
  <>
    <div className="flex items-center gap-1.5 text-gray-500">
      <Icon size={15} className="shrink-0 text-primary" aria-hidden="true" />
      <p className="truncate text-xs font-semibold">{label}</p>
      {linked && (
        <ChevronLeft
          size={15}
          className="ms-auto shrink-0 text-gray-300 transition-colors group-hover:text-primary"
          aria-hidden="true"
        />
      )}
    </div>
    <p className="mt-1.5 truncate text-xl font-extrabold tracking-tight text-accent">{value}</p>
    {secondary && <p className="mt-0.5 truncate text-[11px] leading-5 text-gray-400">{secondary}</p>}
  </>
);

export default function DashboardKpiCard({ icon, label, value, secondary, to, className = "" }) {
  const base = `group block min-w-0 bg-white px-4 py-3.5 ${className}`;

  if (to) {
    return (
      <Link
        to={to}
        className={`${base} transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary/30`}
        aria-label={`${label}: ${value}`}
      >
        <CellContent icon={icon} label={label} value={value} secondary={secondary} linked />
      </Link>
    );
  }

  return (
    <article className={base}>
      <CellContent icon={icon} label={label} value={value} secondary={secondary} />
    </article>
  );
}
